import { useEffect, useState } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { deferIdle } from "@/lib/deferIdle";

/**
 * Toast renderers are mounted after the page is idle. They are imported
 * statically (they're tiny) so a failed dynamic chunk fetch can never
 * blank the whole app.
 */
const DeferredToasters = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    deferIdle(() => setReady(true));
  }, []);

  if (!ready) return null;

  return (
    <>
      <Toaster />
      <Sonner />
    </>
  );
};

export default DeferredToasters;
